import z from "zod";
import { AuditMetaSchema } from "./auditMetaTypes";
import { GrantsSchema, InvitationSchema, RoleSchema } from "./grantsTypes";
import { OrganizationIdSchema, ProjectIdSchema, WorkspaceIdSchema } from "./idTypes";
import { TenancySchema } from "./tenancyTypes";

export const ProjectSchema = z
  .object({
    id: ProjectIdSchema,
    name: z.string(),
    description: z.string(),
    default: z.boolean().optional(),
    grants: GrantsSchema,
    role: RoleSchema.optional(),
    // What holds `role` up: the project's organization, or a grant on this
    // project alone. Absent when no grant sourced it.
    roleSource: z.enum(["organization", "project"]).optional(),
    createdByName: z.string().optional(),
  })
  .extend(TenancySchema.shape)
  .extend({
    projectId: ProjectIdSchema,
    workspaceId: WorkspaceIdSchema,
  })
  .extend(AuditMetaSchema.shape);
export type Project = z.infer<typeof ProjectSchema>;

export const ProjectWithInvitesSchema = ProjectSchema.extend({
  invites: z.array(InvitationSchema).nullable().optional(),
});

export const BillingModeSchema = z.enum(["org", "caller", "explicit"]);
export type BillingMode = z.infer<typeof BillingModeSchema>;

export const CreatableBillingModeSchema = z.enum(["caller", "org"]);
export type CreatableBillingMode = z.infer<typeof CreatableBillingModeSchema>;

export const BillingContextResponseSchema = z.object({
  projectId: ProjectIdSchema,
  payingOrgId: OrganizationIdSchema,
  payingOrgName: z.string(),
  billingMode: BillingModeSchema,
  balance: z.number(),
  isOwnPlan: z.boolean(),
  planType: z.string(),
  payingOrgOwnerEmail: z.string().optional(),
});
export type BillingContextResponse = z.infer<typeof BillingContextResponseSchema>;
